const RestrictedRoutesForShiftManager = [
  '/supervisor/account',
  '/supervisor/shiftlist',
  '/supervisor/timesheets',
  '/supervisor/nurses',
  '/supervisor/alert',
  '/supervisor/shiftdetail/new',
];

export default RestrictedRoutesForShiftManager;
